import Vue from 'vue/dist/vue.esm.js';

Vue.component('checkout-payment-methods', {
    template: `#checkout-payment-methods`,
    delimiters: ['[[', ']]'],
    props: {

        hasUser: {
            required: true,
            type: Number,
        },
        userCards: {
            required: false,
            type: Array,
        },
        paymentMethods: {
            required: false,
            type: Array,
        }
    },

    mounted() {

        if (this.$refs.selectedPaymentMethod.dataset.val !== '') {
            this.selectPaymentMethod(this.$refs.selectedPaymentMethod.dataset.val);
        }

        if (parseInt(this.$refs.selectedCard.dataset.val)) {
            this.selectCard(this.userCards.filter(d => d.id === parseInt(this.$refs.selectedCard.dataset.val))[0]);
        }
    },


    data() {
        return {

            selectedPaymentMethod: null,
            selectedCard: null,

        }
    },

    methods: {

        validateRef(ref) {
            if (this.$refs[ref] !== undefined) {
                return true;
            }
            return false;
        },
        getAvailableMethods() {

            let methods = this.paymentMethods;

            if (this.isGift) {
                methods = methods.filter(pm => pm.isAvailableForGift === true);
            }

            return methods;
        },

        selectPaymentMethod(paymentMethod) {

            if (paymentMethod ===
                this.selectedPaymentMethod) {
                return;
            }
            this.selectedPaymentMethod = paymentMethod;
            this.selectedCard = null;

            if (paymentMethod === 'credit_card' && this.userCards.length > 1) {
                this.selectCard(this.userCards.filter(d => d.isPrimary === true)[0]);
            }
        },
        selectCard(card) {
            if (card === this.selectedCard) {
                return;
            }
            this.selectedCard = card;
        },

    },

    computed: {}
});